import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	// const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "VkZpaidZRL",
				"width": 422.4,
				"height": 87.34375,
				"left": 293.7,
				"top": 158.33,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 67.35px;font-family: +mj-ea;\">谢谢观看</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "yRmFkLGgIj",
				"width": 476.51,
				"height": 44.484375,
				"left": 261.77,
				"top": 244.38,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 24.49px;font-family: 仿宋;\">Thanks&nbsp;for&nbsp;watching</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "1JdtZsezFC",
				"width": 199.23410011918952,
				"height": 40.375,
				"left": 400.4079499404052,
				"top": 344.785,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: Arial;\">汇报人：ChatGpt</span></span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "2lt228wl4m",
				"width": 237.92,
				"height": 40.375,
				"left": 385.94,
				"top": 385.16,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">时间：</span><span style=\"font-size: 18.37px;font-family: Arial;\">xxxx</span><span style=\"font-size: 18.37px;font-family: Arial;\">年</span><span style=\"font-size: 18.37px;font-family: Arial;\">xx</span><span style=\"font-size: 18.37px;font-family: Arial;\">月</span><span style=\"font-size: 18.37px;font-family: Arial;\">xx</span><span style=\"font-size: 18.37px;font-family: Arial;\">日</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
		],
		background
	};

}